module.exports = __webpack_public_path__ + "img/amor-shadow.a5837bef.png";